import React from "react";
export const TextInput = ({ value, displayError, onChange, onFinish, id, errorText, placeholder, wide, }) => {
    let className = "form-group";
    if (!wide) {
        className += " is-half";
    }
    if (displayError) {
        className += " has-error";
    }
    return (React.createElement("div", { className: className },
        React.createElement("div", { "data-ecom-inputtext": true },
            React.createElement("input", { id: id, type: "text", placeholder: placeholder, value: value || "", onChange: (e) => onChange(e.target.value), onBlur: onFinish })),
        React.createElement("div", { className: "form-alert" }, errorText)));
};
export const DropDownInput = ({ value, options, onChange, }) => (React.createElement("div", { className: "form-group" },
    React.createElement("div", { "data-ecom-select": true },
        React.createElement("select", { className: "select", onChange: (e) => onChange(e.target.value), value: value }, options.map((option, index) => (React.createElement("option", { key: `${index}-${option}` }, option)))))));
